import React, { useEffect, useState } from "react";
import * as Icons from "lucide-react";
import api from "@/lib/api";

const LEVEL_STYLES = {
  info:    { bg: "bg-sky-600",     text: "text-white", icon: "Info" },
  warning: { bg: "bg-amber-500",   text: "text-black", icon: "AlertTriangle" },
  success: { bg: "bg-emerald-600", text: "text-white", icon: "CheckCircle2" },
  brand:   { bg: "bg-gradient-to-r from-brand-blue via-brand-blue to-brand-orange", text: "text-white", icon: "Megaphone" },
};

export default function AnnouncementBanner() {
  const [data, setData] = useState(null);
  const [dismissed, setDismissed] = useState(false);

  useEffect(() => {
    api.get("/settings/announcement")
      .then(r => setData(r.data))
      .catch(() => {});
  }, []);

  if (!data || !data.active_now || !data.message || dismissed) return null;

  const style = LEVEL_STYLES[data.level] || LEVEL_STYLES.brand;
  const IconCmp = Icons[style.icon] || Icons.Megaphone;

  return (
    <div
      role="region"
      aria-label="Site announcement"
      data-testid="announcement-banner"
      className={`${style.bg} ${style.text} shadow-sm`}
    >
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-2.5 flex items-center gap-3">
        <IconCmp className="w-5 h-5 shrink-0" aria-hidden="true" />
        <p className="flex-1 text-sm sm:text-base leading-snug" data-testid="announcement-banner-message">
          {data.message}
          {data.link_url ? (
            <>
              {" "}
              <a
                href={data.link_url}
                target={data.link_url.startsWith("http") ? "_blank" : undefined}
                rel="noreferrer noopener"
                className="underline font-semibold underline-offset-2 hover:opacity-90"
                data-testid="announcement-banner-link"
              >
                {data.link_text || "Learn more"}
                <Icons.ArrowUpRight className="inline w-4 h-4 ml-0.5" aria-hidden="true" />
              </a>
            </>
          ) : null}
        </p>
        <button
          type="button"
          onClick={() => setDismissed(true)}
          className="opacity-80 hover:opacity-100 shrink-0 rounded-full p-1 hover:bg-black/10"
          aria-label="Dismiss announcement"
          data-testid="announcement-banner-close"
        >
          <Icons.X className="w-4 h-4" />
        </button>
      </div>
    </div>
  );
}
